import {BaseException} from './base.exception';

export class InitialComponentDataValidationException extends BaseException {
    constructor(messages: string[]) {
        super([], messages);
    }
}
